import React from 'react';

export const WhoItsFor = () => {
  const goodFit = [
    'AI products with real user conversations',
    'Teams that need insight beyond raw logs',
    'PMs working with conversational interfaces',
  ];

  const notAFit = [
    'Pageview-only analytics needs',
    'Products without user-generated text',
    'General-purpose BI use cases',
  ];

  return (
    <section className="py-32 md:py-40 bg-gradient-to-b from-slate-50 via-white to-slate-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-green-500/5 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-0 w-[400px] h-[400px] bg-slate-500/5 rounded-full blur-[120px]" />
      </div>

      <div className="section-container relative z-10">
        <div className="text-center mb-20">
          <p className="text-turret-purple font-semibold tracking-wide uppercase text-sm mb-4">
            Is Turret Right For You?
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 tracking-tight mb-6">
            Built for AI product teams
          </h2>
          <p className="text-xl text-neutral-500 max-w-xl mx-auto">
            The right tool for the right use case
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {/* Good Fit */}
          <div className="relative group">
            <div className="absolute -inset-2 bg-gradient-to-b from-green-500 to-emerald-600 rounded-[32px] opacity-0 group-hover:opacity-[0.08] blur-2xl transition-opacity duration-700" />
            <div className="relative h-full p-8 lg:p-10 rounded-[28px] bg-white border border-slate-200/80 shadow-sm hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-500">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-green-500/25">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-neutral-900 tracking-tight">Good Fit</h3>
              </div>

              <ul className="space-y-5">
                {goodFit.map((item, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5">
                      <svg
                        className="w-3.5 h-3.5 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.5"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <span className="text-neutral-600 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Not a Fit */}
          <div className="relative group">
            <div className="absolute -inset-2 bg-gradient-to-b from-slate-400 to-slate-500 rounded-[32px] opacity-0 group-hover:opacity-[0.08] blur-2xl transition-opacity duration-700" />
            <div className="relative h-full p-8 lg:p-10 rounded-[28px] bg-white border border-slate-200/80 shadow-sm hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-500">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-slate-400 to-slate-500 flex items-center justify-center shadow-lg shadow-slate-500/25">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-neutral-900 tracking-tight">Not a Fit</h3>
              </div>

              <ul className="space-y-5">
                {notAFit.map((item, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center mt-0.5">
                      <svg
                        className="w-3.5 h-3.5 text-slate-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.5"
                          d="M20 12H4"
                        />
                      </svg>
                    </div>
                    <span className="text-neutral-500 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
